<input type="text" id="scriptHelper" class="sr-only">
<div class="main-content" *ngIf="!transparency">
  <div class="loader"></div>
</div>

<div class="warning-transparency" *ngIf="isWarning === true">
  <svg xmlns="http://www.w3.org/2000/svg" width="55" height="55" viewBox="0 0 24 24" fill="none" stroke="#ffffff"
    stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
    <line x1="12" y1="9" x2="12" y2="13"></line>
    <line x1="12" y1="17" x2="12.01" y2="17"></line>
  </svg>
  <div class="warnig-text">
    <h4>ATENÇÃO</h4>
    <p>As informações de transparecia sobre o impacto gerado, só serão exibidas depois do repasse.</p>
  </div>
  <svg (click)="isWarning=false" class="close-btn" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
    viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="15" y1="9" x2="9" y2="15"></line>
    <line x1="9" y1="9" x2="15" y2="15"></line>
  </svg>
</div>

<div class="main-content" *ngIf="transparency">
  <div class="container-fluid">
    <a style="float:right; position: sticky; top: 0;" target="_blank"
      href="https://opolen.com.br/impacto/{{ transparency.seoUrl }}" class="btn btn-success btn-fill">Ver Página de
      Transparência</a>
    <div class="col-lg-8 col-md-12">

    <!--Dados Iniciais-->
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">TOPO DA PÁGINA (HERO)</h4>
        </div>
        <div class="card-content">
          <form name="form" (ngSubmit)="f.form.valid && saveTransparency()" #f="ngForm" novalidate>
            <div class="row">
              <div class="col-md-8 col-xs-8">
                <div class="form-group">
                  <label> Url da sua logo </label>
                  <br>
                  <small>Para alterar acesse "Dados da empresa" clique <a href="#/profile/perfil">aqui</a> </small>
                  <input class="form-control" type="text" name="logo" [(ngModel)]="transparency.logo" required
                    #logo="ngModel" readonly>
                  <small [hidden]="logo.valid || (logo.pristine && !f.submitted)" class="text-danger">
                    Este campo é obrigatório
                  </small>
                </div>
              </div>
              <div class="col-md-4 col-xs-4" *ngIf="isTransparencyPro || authenticationService.hasFeature('pagina-transparencia-premium')">
                <div class="form-group">
                  <label>Cor Principal</label>
                  <br>
                  <div class="color-box">
                    <input type="text" id="text-color" name="backGroundColor" [(ngModel)]="transparency.backGroundColor"
                      data-control="brightness" required #mainColor="ngModel">
                    <input id="mainColor" type="color" name="backGroundColor" [(ngModel)]="transparency.backGroundColor"
                      data-control="brightness" required #mainColor="ngModel">
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-xs-12" *ngIf="isTransparencyPro || authenticationService.hasFeature('pagina-transparencia-premium')">
                <div class="form-group">
                  <label> Imagem do Banner </label>
                  <br>
                  <small>Se você deseja alterar a imagem do fundo do banner principal. (Não
                    obrigatório)</small>
                  <div>
                    <div class="col-md-6 col-xs-12"
                      *ngIf="transparency.transparencyBackGround != null && transparency.transparencyBackGround.length > 0">
                      <img class="causeImage" src="{{transparency.transparencyBackGround}}?v={{ticker}}"
                        style="max-width: 400px;padding: 5px;" />
                      <a (click)="showDeleteModal('Banner')" href="void:javascript()"
                        style="position: absolute;top: 0;margin-left: -15px;"
                        class="float-right p-0 btn btn-sm btn-danger btn-round bg-red-500 border-red-500 white-text waves-effect waves-light waves-round">
                        X
                      </a>
                    </div>
                    <div class="col-md-6 col-xs-12" *ngIf="transparency.transparencyBackGround == null">
                      <input class="form-control ng-pristine ng-invalid ng-touched" #fileUpload type="file"
                        (change)="fileChangeEvent($event, 'background')" placeholder="Adicione uma Imagem..." multiple
                        accept=".png,.jpg,.gif,.jpeg" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-xs-12" *ngIf="isTransparencyPro || authenticationService.hasFeature('pagina-transparencia-premium')">
                <div class="form-group">
                  <label> Frase do Hero </label>
                  <br><small>Descreva em poucas palavras o impacto da sua loja. (50
                    caracteres)</small>
                  <input class="form-control" type="text" name="impactSlogan" [(ngModel)]="transparency.impactSlogan"
                    required #impactSlogan="ngModel">
                  <small [hidden]="impactSlogan.valid || (impactSlogan.pristine && !f.submitted)" class="text-danger">
                    Este campo é obrigatório
                  </small>
                </div>
              </div>
              <div class="col-md-12 col-xs-12">
                <div class="form-group">
                  <label> Link do seu site </label>
                  <br><small>Para qual página do seu site a página de transparência irá
                    redirecionar?</small>
                  <input class="form-control" type="text" name="utmUrl" [(ngModel)]="transparency.utmUrl" required
                    #utmUrl="ngModel">
                  <small [hidden]="utmUrl.valid || (utmUrl.pristine && !f.submitted)" class="text-danger">
                    Este campo é obrigatório
                  </small>
                </div>
              </div>
            </div>
            <div class="text-right">
              <button type="submit" class="btn btn-info btn-fill">Atualizar dados</button>
            </div>
          </form>
        </div>
      </div>

      <!--Sobre o valor doado-->
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">SOBRE E TOTAL DOADO</h4>
        </div>
        <div class="card-content">
          <form name="form" (ngSubmit)="f.form.valid && saveTransparency()" #f="ngForm" novalidate>
            <div class="row">
              <div class="col-md-12 col-xs-12">
                <div class="form-group">
                  <label> Descrição Curta da {{transparency.name}} </label>
                  <br><small>Descreva sua loja aqui. (300 caracteres)</small>
                  <textarea class="form-control" name="description" [(ngModel)]="transparency.description"
                    #description="ngModel">{{script}}</textarea>
                  <small [hidden]="description.valid || (description.pristine && !f.submitted)" class="text-danger">
                    Este campo é obrigatório
                  </small>
                </div>
              </div>
              <div class="col-md-12 col-xs-12 value-or-impact">
                <div class="form-group">
                  <label> Como exibir valor doado e/ou impacto gerado? </label>
                  <br><small>Selecione qual informação você quer exibir no impacto gerado em cada
                    instituição. Se é o <b>valor doado (ex.: R$1300,00)</b> ou o <b>impacto (ex.: 30
                      pratos de comida)</b> ou
                    ambos</small>
                  <select class="form-control" name="impactVisualizationType"
                    [(ngModel)]=" transparency.impactVisualizationType">
                    <option value="0">Exibir ambos, valor e impacto</option>
                    <option value="1">De preferência o impacto, se não houver cadastrado, o valor
                      doado
                    </option>
                    <option value="2">Apenas o valor doado (nunca o impacto)</option>
                    <option value="3">Apenas o impacto (nunca o valor doado)</option>
                  </select>
                </div>
              </div>
              <div class="col-md-12 col-xs-12 imapact-section">
                <label>O layout pode ser diferente na sua página de transparencia.</label>
                <img src="../../assets/img/transparency/impact.png" alt="Impacto"
                  *ngIf="transparency.impactVisualizationType == 1 || transparency.impactVisualizationType == 3">
                <img src="../../assets/img/transparency/value.png" alt="Valor"
                  *ngIf="transparency.impactVisualizationType == 2">
                <img src="../../assets/img/transparency/impact-value.png" alt="Impacto e valor"
                  *ngIf="transparency.impactVisualizationType == 0">

              </div>
            </div>
            <div class="text-right">
              <button type="submit" class="btn btn-info btn-fill">Atualizar dados</button>
            </div>
          </form>
        </div>
      </div>

      <!--Nosso Impacto-->
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">NOSSO IMPACTO</h4>
          <small>Selecione quais causas que você apoia que você quer que seja exibido em sua página de
            transparência</small>
        </div>
        <div class="card-content">
          <form name="form" (ngSubmit)="f.form.valid && saveTransparency()" #f="ngForm" novalidate>
            <div *ngIf="transparency.listNgoImpact == null || transparency.listNgoImpact.length == 0"
              class="alert alert-danger">
              <button type="button" aria-hidden="true" class="close">×</button>
              <span>Ainda não foi realizado doações para as instituições. Após isso é possível
                ativar/desativar Ongs que aparecerão na sua página de transparência.</span>
            </div>
            <div *ngIf="transparency.listNgoImpact != null && transparency.listNgoImpact.length > 0"
              class="panel-group">
              <div class="panel panel-border panel-default">
                <div class="panel-heading">
                  <table style="width:100%">
                    <tr>
                      <td>Exibir</td>
                      <td>Logo</td>
                      <td>Causa</td>
                    </tr>
                  </table>
                </div>
              </div>
              <div class="panel panel-border panel-default"
                *ngFor="let ngo of transparency.listNgoImpact; let i = index" [attr.data-index]="i">
                <div class="panel-heading list-ngo">
                  <div class="img-checkbox-ngo">
                    <div class="checkbox-ngo">
                      <label class="switch">
                        <input type="checkbox" name="show" [checked]="ngo.show" (change)="ngo.show = !ngo.show">
                        <span class="slider round"></span>
                      </label>
                    </div>

                    <div class="img-ngo">
                      <img src="{{ngo.ngoLogo}}" style="width: 100px" />
                    </div>
                  </div>

                  <div class="name-ngo">
                    <a href="https://polen.com.br/{{ngo.ngoUrl}}" target="_blank">{{ngo.ngoName}}
                    </a>
                  </div>

                </div>
              </div>
            </div>
            <div *ngIf="transparency.listNgoImpact != null && transparency.listNgoImpact.length > 0" class="text-right">
              <button type="submit" class="btn btn-info btn-fill">Atualizar dados</button>
            </div>
          </form>
        </div>
      </div>

      <!--Relacionamento-->
      <div class="card" *ngIf="transparency.relationInfos != null">
        <div class="card-header">
          <h4 class="card-title">Relacionamento com as causas apoiadas</h4>
        </div>
        <div class="card-content">
          <form name="form" (ngSubmit)="f.form.valid && saveTransparency()" #f="ngForm" novalidate>
            <div class="row">
              <div class="col-md-12 col-xs-12">
                <div class="form-group">
                  <p>
                    Gostaríamos de saber como você deseja se comunicar com os nossos investidores
                    sociais.
                  </p>
                  <hr>
                  <div class="row" *ngFor="let info of transparency.relationInfos" style="margin-bottom: 20px;">
                    <div class="col-md-12 relationInfoContainer">
                      <input name="{{info.id}}" value="{{info.name}}" id="{{info.id}}" style="width: 22px;"
                        type="checkbox" class="switch" (change)="updateRelationInfos($event)"
                        [checked]="info.isSelected" />
                      <label style="width: 90%;" for="{{info.id}}">{{info.name}}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-xs-12">
                <div class="form-group">
                  <br><small>Nos conte melhor como você gostaria de se relacionar com as causas e o
                    que você espera dessa parceria. (300 caracteres)</small>
                  <textarea class="form-control" name="relationNgoDescription"
                    [(ngModel)]="transparency.relationNgoDescription"
                    #relationNgoDescription="ngModel">{{script}}</textarea>
                </div>
              </div>
            </div>
            <div class="text-right">
              <button type="submit" class="btn btn-info btn-fill">Atualizar dados</button>
            </div>
          </form>
        </div>
      </div>

      <!--Depoimento-->
      <div class="card" *ngIf="!isTransparencyPro && !authenticationService.hasFeature('pagina-transparencia-premium')">
        <div class="card-header">
          <h4 class="card-title">DEPOIMENTO</h4>
          <br><small>Descreva o porquê sua loja esta polinizando e apoiando causas. Isso humaniza sua marca e
            da mais credibilidade à sua página de transparência.</small>
        </div>
        <hire-feature [featureId]="'pagina-transparencia-premium'" [name]="'Depoimento'"
          [description]="'ter depoimento na tela de transparência'"></hire-feature>
      </div>
      <div class="card" *ngIf="isTransparencyPro || authenticationService.hasFeature('pagina-transparencia-premium')">
        <div class="card-header">
          <h4 class="card-title">DEPOIMENTO</h4>
          <br><small>Descreva o porquê sua loja esta polinizando e apoiando causas. Isso humaniza sua marca e
            da mais credibilidade à sua página de transparência.</small>
        </div>
        <div class="card-content">
          <form name="form" (ngSubmit)="f.form.valid && saveTransparency()" #f="ngForm" novalidate>
            <div class="row">
              <div class="col-md-12 col-xs-12">
                <div class="form-group">
                  <label>Depoimento </label>&nbsp;<small>(500 caracteres)</small>
                  <textarea style="height: 120px;" class="form-control" name="testimony"
                    [(ngModel)]="transparency.testimony" row="6" #testimony="ngModel" required>{{script}}</textarea>
                    <small [hidden]="!f.submitted" class="text-danger">
                        Este campo é obrigatório
                    </small>
                </div>
              </div>
              <!--Foto-->
              <div class="col-md-12 col-xs-12">
                <div class="form-group">
                  <label> Foto de quem deixou o depoimento </label>
                  <br>
                  <small>Adicione uma foto quadrada de quem deixará o depoimento.</small>
                  <div *ngIf="transparency.testimonyPicture != null && transparency.testimonyPicture.length > 0">
                    <div class="col-md-6 col-xs-12">
                      <img class="causeImage" src="{{transparency.testimonyPicture}}?v={{ticker}}"
                        alt="{{transparency.testimonyOwnerName}}" style="    width: 150px;padding: 5px;" />
                      <a (click)="showDeleteModal('TestemonyLogo')" href="void:javascript()"
                        style="position: absolute;top: 0 px;margin-left: -15px;"
                        class="float-right p-0 btn btn-sm btn-danger btn-round bg-red-500 border-red-500 white-text waves-effect waves-light waves-round">
                        X
                      </a>
                    </div>

                    <!-- <div class="col-md-6 col-xs-12">
                      <label> Alterar Foto:</label>
                      <input class="form-control ng-pristine ng-invalid ng-touched" #fileUpload type="file"
                        (change)="fileChangeEvent($event, 'testimony')" placeholder="Adicione uma foto..." multiple
                        accept=".png,.jpg,.gif,.jpeg" />                        
                    </div> -->

                  </div>
                  <div *ngIf="transparency.testimonyPicture == null">
                    <input class="form-control ng-pristine ng-invalid ng-touched" #fileUpload type="file"
                      (change)="fileChangeEvent($event, 'testimony')" placeholder="Adicione uma foto..." multiple
                      accept=".png,.jpg,.gif,.jpeg" />
                  </div>
                </div>
              </div>
              <!--Nome e cargo-->
              <div class="col-md-6 col-xs-12">
                <div class="form-group">
                  <label> Nome </label>
                  <input class="form-control" type="text" name="testimonyOwnerName"
                    [(ngModel)]="transparency.testimonyOwnerName" maxlength="85" #testimonyOwnerName="ngModel" required>
                    <small [hidden]="!f.submitted" class="text-danger">
                        Este campo é obrigatório
                    </small>
                </div>
              </div>
              <div class="col-md-6 col-xs-12">
                <div class="form-group">
                  <label> Cargo </label>
                  <input class="form-control" type="text" name="testimonyOwnerJobPosition"
                    [(ngModel)]="transparency.testimonyOwnerJobPosition" maxlength="85"
                    #testimonyOwnerJobPosition="ngModel"
                    required>
                    <small [hidden]="!f.submitted" class="text-danger">
                        Este campo é obrigatório
                    </small>
                </div>
              </div>
            </div>
            <div class="text-right">
              <button type="submit" class="btn btn-info btn-fill">Atualizar dados</button>
            </div>
          </form>
        </div>
      </div>

    </div>
  </div>
</div>

<!--Modal Pop Up-->

  
<div id="welcome" *ngIf="showWelcome">

  <div class="welcome-container">
    
      <div class="welcome-left">
          <div class="welcome-text">
              <h2>Página de Transparência</h2>
              <p>
              Ouso dizer, que essa é uma das páginas importantes da sua ação. É ela que mostrará para seus clientes o resultado e para onde foi destinado as doações das suas ações, você pode personalizá-la como quiser, com sua marca e suas cores, agora é mão na massa :)
              </p>
          </div>
          
          <button class="button button-purple" *ngIf="!step2" (click)="nextStep()">
              Próximo
          </button>
          <button class="button button-purple" style="width: 80% !important;" *ngIf="step2" (click)="showWelcome = false">
              Personalizar minha página
          </button>
      </div>

      <div class="welcome-rigth">
        <button type="button" class="button button-purple" id="button-close-welcome" (click)="showWelcome = false"> <img src="../../../assets/img/icon/white-theme/fechar.svg" alt=""></button>
          <div class="image-container">
              <img class="img-step1" src="../../../assets/img/transparency-popup/transparency-popup-step1.png" alt="Descrição da primeira entrada."
              *ngIf="step1">
              <img class="img-step2" src="../../../assets/img/transparency-popup/transparency-popup-step2.png" alt="Descrição da segunda entrada."
              *ngIf="step2">
          </div>
          <div class="count-slide">
              <div class="circle" [ngClass]="{'selectStep': step1}" (click)="goTo('step1')"></div>
              <div class="circle" [ngClass]="{'selectStep': step2}" (click)="goTo('step2')"></div>
          </div>
      </div>
      
  </div>

</div>

<div id="show-tutorial" >
  <div class="container-tutorial">
      <p (click)="openTutorial()">Tutorial da página</p>
  </div>
</div>


<!-- Modal de deletar imagem -->
<ngx-smart-modal #deleteModal identifier="deleteModal" customClass="extra-small-modal">
  <div style="margin:10px">
    <h4 class="card-title" style="text-align: center">Tem certeza que quer fazer isso</h4>
    <hr>
    <div class="card-body">
      <p><strong>Essa ação é IRREVERSÍVEL</strong></p>
      <hr>
      <div class="form-group" style="display: flex; place-content: center; margin-top: 15px;">
        <button class="btn btn-danger btn-fill" type="button" (click)="removeImage()">
          Confirmar
        </button>
      </div>
    </div>
  </div>
</ngx-smart-modal>
<!-- FIM Modal de deletar a imagem -->
